var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "container",
      staticClass: "page d-flex justify-content-between",
      class: { hidden: _vm.hidden },
      attrs: { "data-page-number": _vm.pageNumber },
    },
    [
      _c("canvas", {
        ref: "canvas",
        staticClass: "hover-preview",
        class: { horizontal: _vm.isHorizontal },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "mt-1 d-flex w-100 justify-content-center" }, [
        _c(
          "div",
          { staticClass: "d-flex flex-row justify-content-end page-number" },
          [_c("span", [_vm._v(_vm._s(_vm.pageNumber))])]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "d-flex justify-content-end flex-row align-items-center actions",
          },
          [
            _c("icon", {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip.top",
                  value: {
                    title: _vm.include
                      ? _vm.$t("documents.combinePdf.excludeThisPage")
                      : _vm.$t("documents.combinePdf.includeThisPage"),
                  },
                  expression:
                    "{\n          title: include\n            ? $t('documents.combinePdf.excludeThisPage')\n            : $t('documents.combinePdf.includeThisPage')\n        }",
                  modifiers: { top: true },
                },
              ],
              staticClass: "mr-3 clickable",
              attrs: { name: _vm.include ? "eye" : "eye-slash" },
              on: { click: _vm.handleHidden },
            }),
            _vm._v(" "),
            _c(
              "span",
              { class: { disabled: _vm.pageNumber === _vm.currentPage } },
              [
                _c("icon", {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.top",
                      value: {
                        title: _vm.$t("documents.combinePdf.showPagePreview"),
                      },
                      expression:
                        "{\n            title: $t('documents.combinePdf.showPagePreview')\n          }",
                      modifiers: { top: true },
                    },
                  ],
                  staticClass: "clickable d-none d-lg-block pr-1",
                  attrs: { name: "external-link-square" },
                  on: { click: _vm.handlePreview },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }